// extracted by mini-css-extract-plugin
export var component = "ModuleWrapper-module--component--n1JfJ";
export var header = "ModuleWrapper-module--header--jJ0UF";
export var title = "ModuleWrapper-module--title--ruMlp";